module.exports = __webpack_public_path__ + "img/content-img-3.ff0f1529.png";